import { Autocomplete } from '@ijoin/components';
import { type SxProps } from '@mui/material';

import { FC } from 'react';

import { useAdvisoryOrganizationOptions } from './useAdvisoryOrganizationOptions';

type Option = { label: string; value: string };

export const AdvisoryOrganizationAutocomplete: FC<{
  'data-testid'?: string;
  exclude?: string[];
  fullWidth?: boolean;
  getOptionValue?: (option: Option) => string;
  hideError?: boolean;
  label?: string;
  name?: string;
  placeholder?: string;
  required?: boolean;
  sx?: SxProps;
}> = props => {
  const orgs = useAdvisoryOrganizationOptions();

  const options = (orgs.data ?? []).filter(
    o => !props.exclude?.includes(o.value)
  );

  return (
    <Autocomplete<Option>
      data-testid={props['data-testid']}
      fullWidth={props.fullWidth ?? true}
      getOptionValue={props.getOptionValue}
      hideError={props.hideError ?? true}
      label={props.label ?? 'Advisory Organization'}
      loading={orgs.isLoading}
      name={props.name ?? 'advisoryOrganization'}
      options={options}
      placeholder={props.placeholder ?? 'All organizations'}
      required={props.required}
      sx={props.sx}
    />
  );
};

AdvisoryOrganizationAutocomplete.displayName =
  'AdvisoryOrganizationAutocomplete';
